"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.InitPommac = void 0;
//require('select2');
require('slick-carousel');
function InitPommac() {
    const isMobileLayout = function () {
        console.log(window.innerWidth);
        return (window.innerWidth < 1400);
    };
}
exports.InitPommac = InitPommac;
